import { useEffect, useState } from "react";
import { Instagram, Youtube, Mail, Phone } from "lucide-react";
import api from "@/lib/api";
import { ASSETS } from "@/lib/assets";

export default function Contacto() {
  const [s, setS] = useState(null);
  useEffect(() => {
    document.title = "Contacto — Modo Pro";
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const items = s ? [
    { platform: "Instagram", url: s.instagram, handle: "@modopropodcast", icon: Instagram },
    { platform: "YouTube", url: s.youtube, handle: "@ModoProPodcast", icon: Youtube },
    { platform: "TikTok", url: s.tiktok, handle: "@modopropodcast", icon: null },
    { platform: "Spotify", url: s.spotify, handle: "Próximamente", icon: null },
    { platform: "Apple Podcasts", url: s.apple_podcasts, handle: "Próximamente", icon: null },
  ] : [];

  return (
    <main data-testid="contacto-page" className="bg-mp-black min-h-screen pt-32 md:pt-40">
      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-16">
        <div className="mp-eyebrow mb-6">Contacto</div>
        <h1 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em] max-w-3xl">
          Hablemos.
        </h1>
        <p className="mt-6 text-white/70 max-w-2xl">
          Producción, prensa, alianzas, medios. Escríbenos y nuestro equipo te contactará a la brevedad.
        </p>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-24">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-6 space-y-8">
            {s?.email && (
              <a data-testid="contacto-email" href={`mailto:${s.email}`} className="group flex items-start gap-5 border-t border-white/10 pt-6">
                <Mail className="text-mp-orange mt-1" size={18} />
                <div>
                  <div className="mp-eyebrow">Email</div>
                  <div className="mt-2 font-display text-white text-2xl md:text-3xl group-hover:text-mp-orange transition-colors">{s.email}</div>
                </div>
              </a>
            )}
            {s?.phone && (
              <a data-testid="contacto-phone" href={`tel:${s.phone.replace(/[^0-9+]/g, "")}`} className="group flex items-start gap-5 border-t border-white/10 pt-6">
                <Phone className="text-mp-orange mt-1" size={18} />
                <div>
                  <div className="mp-eyebrow">Producción</div>
                  <div className="mt-2 font-display text-white text-2xl md:text-3xl group-hover:text-mp-orange transition-colors">{s.phone}</div>
                </div>
              </a>
            )}
            <div className="border-t border-white/10 pt-6">
              <div className="mp-eyebrow">Ubicación</div>
              <div className="mt-2 font-display text-white text-2xl md:text-3xl">South Florida</div>
              <div className="text-mp-mute text-sm mt-1">Grabaciones presenciales en el estudio Modo Pro.</div>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6">
            <div className="mp-eyebrow mb-4">Escúchanos y síguenos</div>
            <div className="grid grid-cols-1 gap-px bg-white/10">
              {items.map((it) => {
                const disabled = !it.url;
                const Icon = it.icon;
                return disabled ? (
                  <div key={it.platform} data-testid={`social-${it.platform.toLowerCase()}`} className="bg-mp-black p-5 flex items-center justify-between opacity-60 cursor-not-allowed">
                    <div className="flex items-center gap-4">
                      {Icon && <Icon size={18} className="text-mp-mute" />}
                      <span className="font-display text-white text-sm tracking-[0.24em] uppercase">{it.platform}</span>
                    </div>
                    <span className="text-mp-mute text-xs font-display tracking-[0.24em] uppercase">Próximamente</span>
                  </div>
                ) : (
                  <a key={it.platform} href={it.url} target="_blank" rel="noreferrer" data-testid={`social-${it.platform.toLowerCase()}`} className="bg-mp-black p-5 flex items-center justify-between hover:bg-mp-charcoal transition-colors group">
                    <div className="flex items-center gap-4">
                      {Icon && <Icon size={18} className="text-white/80 group-hover:text-mp-orange transition-colors" />}
                      <span className="font-display text-white text-sm tracking-[0.24em] uppercase group-hover:text-mp-orange transition-colors">{it.platform}</span>
                    </div>
                    <span className="text-mp-mute text-xs">{it.handle}</span>
                  </a>
                );
              })}
            </div>
            <div className="mt-10 aspect-[16/10] overflow-hidden border border-white/10">
              <img src={ASSETS.studioEmpty} alt="Estudio Modo Pro" className="h-full w-full object-cover" />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
